import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DpFormModule } from '@docpath/webcomponents';
import { TranslateModule } from '@ngx-translate/core';

import { SelfMaintenanceComponent } from './self-maintenance.component';

@NgModule({
    declarations: [
        SelfMaintenanceComponent
    ],
    imports: [
        CommonModule,
        DpFormModule,
        TranslateModule
    ],
    providers: [

    ]
})
export class SelfMaintenanceModule { }


